module.exports = __webpack_public_path__ + "media/images/admin/icons/paperclip-af7f585d9640a879d268b5b73b078eb2.svg";